import React, { useState } from "react";
import { Users, Tag, Package, DollarSign, ShieldAlert } from "lucide-react";

import UsersTable from "./UsersTable";
import CouponManagement from "./CouponManagement";
import PlanManagement from "./PlanManagement";
import PaymentManagement from "./PaymentManagement";
import StatsCards from "./StatsCards";
import DeletedOrdersManager from "./DeletedOrdersManager";

const SuperAdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("users");
  const [selectedUserId, setSelectedUserId] = useState(null);

  const tabs = [
    { id: "users",    label: "Users",    icon: Users },
    { id: "coupons",  label: "Coupons",  icon: Tag },
    { id: "plans",    label: "Plans",    icon: Package },
    { id: "payments", label: "Payments", icon: DollarSign },
    { id: "deleted-orders", label: "Deleted Orders", icon: ShieldAlert },
  ];

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900">
          Super Admin Dashboard
        </h1>
        <p className="text-gray-600">
          Manage users, subscriptions, coupons, plans, and payments
        </p>
      </div>

      {/* Stats */}
      <StatsCards />

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex justify-center gap-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`group relative flex items-center gap-2 py-4 px-2 border-b-2 font-medium text-sm transition
          ${
            activeTab === tab.id
              ? "border-blue-500 text-blue-600"
              : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
          }
        `}
            >
              {/* Icon (always visible) */}
              <tab.icon className="h-5 w-5" />

              {/* Label (hidden on mobile) */}
              <span className="hidden md:inline">{tab.label}</span>

              {/* Tooltip (mobile + hover fallback) */}
              <span
                className="
            absolute -bottom-8 left-1/2 -translate-x-1/2
            whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white
            opacity-0 group-hover:opacity-100 md:hidden
            pointer-events-none transition
          "
              >
                {tab.label}
              </span>
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow p-4">
        {activeTab === "users" && (
          <UsersTable onUserSelect={handleUserSelect} />
        )}

        {activeTab === "coupons" && <CouponManagement />}

        {activeTab === "plans" && <PlanManagement />}

        {activeTab === "payments" && <PaymentManagement />}

        {activeTab === "deleted-orders" && (
          <DeletedOrdersManager />
        )}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
